var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*
* Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
*/
/*******************************************************************
 * @author JiHoon Park
 * @contact jhpark@detech.co.kr
 * @date 2022-07-19
 * @brief EHP 회사/사업장/세부사업장 개발
 *
 ********************************************************************/
import React, { useEffect, useRef, useState } from "react";
// img, css etc
import ReactCrop, { makeAspectCrop, centerCrop, } from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
// utils
import clog from "../../../utils/logUtils";
import * as CUTIL from "../../../utils/commUtils";
import { CanvasPreview } from './CanvasPreview';
/**
 * @brief EHP 이미지 크롭 컴포넌트
 * @param -
 * @returns react components
 */
//component
function EhpImageCrop(props) {
    const popBody = props.popBody;
    const cropImage = (!CUTIL.isnull(popBody))
        ? popBody.hasOwnProperty("props")
            ? popBody.props.hasOwnProperty("cropImage")
                ? popBody.props.cropImage
                : null
            : null
        : null;
    const setParentCropedImage = (!CUTIL.isnull(popBody))
        ? popBody.hasOwnProperty("props")
            ? popBody.props.hasOwnProperty("setCropedImage")
                ? popBody.props.setCropedImage
                : null
            : null
        : null;
    const imgRef = useRef(null);
    clog("IN EHPCROPIMAGE : INIT : " + JSON.stringify(cropImage));
    //clog("IN EHPCROPIMAGE : INIT : " + JSON.stringify(popBody));
    const [crop, setCrop] = useState(
    /*{
    unit: '%', // Can be 'px' or '%'
    x: 25,
    y: 25,
    width: 50,
    height: 50
  }*/
    );
    const dw = 300;
    const dh = 300;
    const [fixWidth, setFixWidth] = useState(dw);
    const [fixHeight, setFixHeight] = useState(dh);
    function handleSetCrop(crop) {
        clog("handleSetCrop : " + crop.width + " X " + crop.height);
        setCrop(Object.assign(Object.assign({}, crop), { width: crop.width, height: crop.width }));
        //setCrop({...crop, width:fixWidth, height:fixHeight});
    }
    const [completedCrop, setCompletedCrop] = useState();
    useEffect(() => {
        setCompletedCrop(null);
        setFixWidth(dw);
        setFixHeight(dh);
    }, [popBody]);
    function onImageLoad(e) {
        const { naturalWidth: width, naturalHeight: height } = e.currentTarget;
        //clog("onImageLoad : " + width + " X " + height);
        if (width < fixWidth) {
            setFixWidth(width);
            setFixHeight(height);
        }
        const crop = centerCrop(makeAspectCrop({
            // You don't need to pass a complete crop into
            // makeAspectCrop or centerCrop.
            //unit: '%',
            unit: 'px',
            width: (width < fixWidth) ? width : fixWidth,
        }, 
        //16 / 9,
        1 / 1, (width < fixWidth) ? width : fixWidth, (width < fixWidth) ? height : fixHeight), (width < fixWidth) ? width : fixWidth, (width < fixWidth) ? height : fixHeight);
        setCrop(crop);
    }
    function onCloseCropSrc(objURL) {
        window.URL.revokeObjectURL(objURL);
    }
    const previewCanvasRef = useRef(null);
    const [scale, setScale] = useState(1);
    const [rotate, setRotate] = useState(0);
    useDebounceEffect(() => __awaiter(this, void 0, void 0, function* () {
        if ((completedCrop === null || completedCrop === void 0 ? void 0 : completedCrop.width) &&
            (completedCrop === null || completedCrop === void 0 ? void 0 : completedCrop.height) &&
            imgRef.current &&
            previewCanvasRef.current) {
            // We use canvasPreview as it's much faster than imgPreview.
            CanvasPreview(imgRef.current, previewCanvasRef.current, completedCrop, scale, rotate);
        }
    }), 100, [completedCrop, scale, rotate]);
    function getCroppedImg(image, pixelCrop, fileName) {
        //clog("CROP : getCroppedImg : " + JSON.stringify(pixelCrop));
        const canvas = previewCanvasRef.current;
        // As Base64 string
        const base64Image = canvas.toDataURL('image/jpeg');
        return base64Image;
    }
    function onClickSaveCropedImage() {
        return __awaiter(this, void 0, void 0, function* () {
            const fileUrl = yield getCroppedImg(imgRef.current, completedCrop, cropImage.name);
            //clog("IN CROP COMP : SET PARENT FILE : " + fileUrl);
            setParentCropedImage({ name: cropImage.name, url: fileUrl });
            CUTIL.jsclose_Popup("pop-imgcrop");
        });
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { id: "pop-imgcrop", className: "popup-layer js-layer layer-out hidden popup-basic imgcrop", style: { "display": "" } },
            React.createElement("div", { className: "popup__head" },
                React.createElement("h1", null, "Image Edit"),
                React.createElement("button", { className: "btn btn-close js-close", onClick: (e) => onCloseCropSrc(cropImage.url) },
                    React.createElement("span", { className: "hide" }, "\uB2EB\uAE30"))),
            React.createElement("div", { className: "popup__body" },
                React.createElement(ReactCrop, { crop: crop, 
                    //onChange={(crop, pcrop)=>setCrop(crop)}
                    onChange: (crop, pcrop) => handleSetCrop(crop), onComplete: (e) => setCompletedCrop(e) }, (cropImage)
                    ? React.createElement("img", { ref: imgRef, src: cropImage.url, onLoad: onImageLoad, "object-fit": "cover" })
                    : React.createElement("img", { ref: imgRef, src: require("/static/img/img_workplace/bg_add.jpg"), alt: "\uC0AC\uC9C4\uC601\uC5ED", onLoad: onImageLoad })),
                React.createElement("div", null, Boolean(completedCrop) && (React.createElement("canvas", { ref: previewCanvasRef, style: {
                        border: '0px solid black',
                        objectFit: 'contain',
                        width: 0,
                        height: 0, //completedCrop.height,
                    } })))),
            React.createElement("div", { className: "popup__footer" },
                React.createElement("button", { type: "button", className: "bg-gray js-close", onClick: (e) => onCloseCropSrc(cropImage.url) },
                    React.createElement("span", null, "\uCDE8\uC18C")),
                React.createElement("button", { type: "button", className: `${(completedCrop) ? "" : "bg-gray"}`, 
                    //onClick={(e)=>(completedCrop)&&onClickSaveCropedImage(completedCrop)}
                    onClick: (e) => (completedCrop) && onClickSaveCropedImage() },
                    React.createElement("span", null, "\uC800\uC7A5"))))));
}
export default EhpImageCrop;
export function useDebounceEffect(fn, waitTime, deps) {
    useEffect(() => {
        const t = setTimeout(() => {
            fn.apply(undefined, deps);
        }, waitTime);
        return () => {
            clearTimeout(t);
        };
    }, deps);
}
